/**
 * Get whether the application should be editable.
 */

import { createSelector } from 'reselect';

import getAuthRulesSelector from '/business/shared/state/selectors/auth/getApplicationAuthRulesSelector';
import getApplicationStatusSelector from './getApplicationStatusSelector';

import { applicationStates, userPermissions } from '/business/shared/util/Statics';
import hasBeenUnlockedSelector from '/business/shared/state/selectors/application/model/hasBeenUnlockedSelector';

export default createSelector(
  [getAuthRulesSelector, getApplicationStatusSelector, hasBeenUnlockedSelector],
  (rules, applicationState, isUnlocked) => {
    const matched = rules?.filter((rule) => {
      return rule === userPermissions.CAN_EDIT_APPLICATION_ITEMS;
    });

    // Done as an .includes() check so easy to extend for debugging if your wondering
    const isDraftOrCompleted = applicationState === applicationStates.DRAFT;

    return matched.length > 0 && (isDraftOrCompleted || isUnlocked);
  },
);
